import type { TreeMapFilterCardProps } from "./tree-map-filter-card.type";

import { useTreeMap } from "../tree-map.context";

import TreeMapFilterCard from "./tree-map-filter-card.component";

const TreeMapFilterCardWrapper = ({
  type,
  subFilters,
}: TreeMapFilterCardProps) => {
  const { showLocationsFilters, showAssetsFilters } = useTreeMap();

  if (type === "location" && !showLocationsFilters) return null;

  if (type === "asset" && !showAssetsFilters) return null;

  return <TreeMapFilterCard type={type} subFilters={subFilters} />;
};

export default TreeMapFilterCardWrapper;
